import {useDebugValue} from 'react';

import {
    useMediaActions,
    useMediaEvents,
    useMediaOptions,
    useMediaSettings
} from './';

function useMedia(props) {
    const {
        events
    } = useMediaEvents(props);

    const {
        options
    } = useMediaOptions(props);

    const {
        initialSettings,
        settings,
        changeSettings
    } = useMediaSettings(props);

    useMediaActions({
        events,
        options,
        initialSettings,
        changeSettings
    });

    const result = {
        events,
        options,
        settings
    };

    useDebugValue(result);

    return result;
}

export {useMedia};
